var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.4 213.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 85.93,
    y1: -7.27,
    x2: 191.46,
    y2: 112.58,
    gradientTransform: "translate(43.98 -71.08) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f3be6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 44.06,
    y1: 29.6,
    x2: 149.6,
    y2: 149.44,
    gradientTransform: "translate(150.73 -62.43) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -9.65,
    y1: 76.9,
    x2: 95.89,
    y2: 196.74,
    gradientTransform: "translate(81.36 19.16) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 41.1,
    y1: 32.22,
    x2: 146.63,
    y2: 152.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 44.06,
    y1: 29.6,
    x2: 149.6,
    y2: 149.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.23,
    y: 0,
    width: 35.11,
    height: 35.11,
    rx: 17.56,
    ry: 17.56,
    transform: "translate(19.16 81.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.17,
    y: 133.17,
    width: 35.11,
    height: 35.11,
    rx: 17.56,
    ry: 17.56,
    transform: "translate(-62.43 150.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 90.23,
    width: 35.11,
    height: 35.11,
    rx: 17.56,
    ry: 17.56,
    transform: "translate(-71.08 43.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m167.25,53.32c-5.11-9.63-17.08-11.84-25.25-6.29-.08.06-.16.11-.24.17-7.88,5.66-17.26,8.85-26.96,8.71l-24.86-.37c-5.66,0-11.21-1.94-15.38-5.77-.98-.9-2.09-1.71-3.35-2.42-5.93-3.33-13.42-2.9-18.89,1.14-8.87,6.55-9.56,19.12-2.07,26.61l.05.05c3.34,3.33,5.22,7.86,5.22,12.58v28.23c0,9.29-3.06,18.26-8.38,25.88-.04.06-.08.12-.13.18-4.25,6.25-3.95,14.74.75,20.66,7.09,8.94,20.53,8.94,27.62,0,4.69-5.93,4.99-14.41.75-20.66-.04-.06-.08-.12-.12-.18-5.31-7.63-8.38-16.59-8.38-25.89v-26.82c0-4.93,2.16-9.66,6.01-12.74.5-.4.98-.83,1.44-1.29l.06-.06c4.7-4.73,11.1-7.38,17.76-7.38h23.05c9.32,0,18.26,3.15,25.93,8.44.03.02.06.04.1.07,8.17,5.55,20.14,3.34,25.25-6.29,2.72-5.13,2.72-11.4,0-16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m207.32,92.32c-6.42-5.57-16.17-5.67-22.69-.22-.06.05-.11.09-.17.14-6.17,5.28-13.88,8.4-22,8.4h-28.74c-5.51,0-10.67-2.39-14.55-6.3-.02-.02-.04-.04-.06-.06h0c-6.86-6.86-17.97-6.86-24.83,0h0c-6.86,6.86-6.86,17.97,0,24.83h0s.03.03.05.05c3.24,3.22,5.22,7.49,5.22,12.06v37.61c0,5.51-2.39,10.67-6.3,14.55-.02.02-.04.04-.06.06h0c-6.86,6.86-6.86,17.97,0,24.83h0c6.86,6.86,17.97,6.86,24.83,0h0c6.86-6.86,6.86-17.97,0-24.83h0s-.04-.04-.06-.06c-3.92-3.88-6.3-9.03-6.3-14.54v-35.68c0-4.93,2.16-9.66,6.01-12.74.5-.4.98-.83,1.44-1.29h0s.04-.04.06-.06c3.88-3.92,9.03-6.3,14.55-6.3h31.4c7.19,0,14.24,2.26,19.91,6.69.49.39,1.02.75,1.57,1.09,6.3,3.91,14.57,3.4,20.31-1.3,8.51-6.96,8.64-19.77.4-26.91Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.508021aa248812fb0a6c57e520704dcc.svg";
export { ForwardRef as ReactComponent };